import { render, staticRenderFns } from "./ed-create-class.component.vue?vue&type=template&id=a947831e&scoped=true&"
import script from "./ed-create-class.component.ts?vue&type=script&lang=ts&"
export * from "./ed-create-class.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-class.component.scss?vue&type=style&index=0&id=a947831e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a947831e",
  null
  
)

export default component.exports